import Phaser from "phaser";
import { SeasonType } from "../data/enums";

export class SeasonManager {
    private readonly scene: Phaser.Scene;
    private weatherTimer?: Phaser.Time.TimerEvent;

    constructor(scene: Phaser.Scene) {
        this.scene = scene;
    }

    applySeason(season: SeasonType, waterRect: Phaser.GameObjects.Rectangle, worldWidth: number, worldHeight: number): void {
        this.weatherTimer?.destroy();

        switch (season) {
            case SeasonType.Spring:
                waterRect.setFillStyle(0x1a678f);
                this.spawnAmbientParticles(worldWidth, worldHeight, 0xa3e6ff, 0.22, 900);
                break;
            case SeasonType.Summer:
                waterRect.setFillStyle(0x1b74a8);
                this.spawnAmbientParticles(worldWidth, worldHeight, 0xfff5a8, 0.18, 1000);
                break;
            case SeasonType.Fall:
                waterRect.setFillStyle(0x225b7f);
                this.spawnAmbientParticles(worldWidth, worldHeight, 0xffc87d, 0.2, 850);
                break;
            case SeasonType.Winter:
                waterRect.setFillStyle(0x2f6388);
                this.spawnAmbientParticles(worldWidth, worldHeight, 0xe7f4ff, 0.32, 600);
                break;
        }
    }

    private spawnAmbientParticles(worldWidth: number, worldHeight: number, color: number, alpha: number, intervalMs: number): void {
        this.weatherTimer = this.scene.time.addEvent({
            loop: true,
            delay: intervalMs,
            callback: () => {
                const particle = this.scene.add.circle(Phaser.Math.Between(0, worldWidth), Phaser.Math.Between(0, worldHeight), Phaser.Math.Between(1, 3), color, alpha).setDepth(-18);
                this.scene.tweens.add({
                    targets: particle,
                    y: particle.y + Phaser.Math.Between(20, 60),
                    alpha: 0,
                    duration: Phaser.Math.Between(1800, 2800),
                    onComplete: () => particle.destroy(),
                });
            },
        });
    }
}
